import { getRFXRequestAuditRecordsQuery } from 'gql/queries/getRFXRequestAuditRecordsQuery';
import { RFXRequestAuditRecord } from 'interfaces/RFXAuditRecordModel';

import { UIInput } from '../../types/uiTypes';

export interface GetRFXRequestAuditRecordsInput extends UIInput {
  rfxId: string;
  revision: number;
}

export async function getRFXRequestAuditRecords({
  apolloClient,
  rfxId,
  revision
}: GetRFXRequestAuditRecordsInput): Promise<RFXRequestAuditRecord[]> {
  const variables = {
    rfxRequestRevisionedId: {
      id: {
        value: rfxId
      },
      revision: revision
    },
    maxResults: 100
  };

  const response = await apolloClient.query({
    query: getRFXRequestAuditRecordsQuery,
    variables,
    fetchPolicy: 'network-only'
  });

  return response.data.getRFXRequestAuditRecords.rfxRequestAuditRecords as RFXRequestAuditRecord[];
}
